import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=1bc3cf0a&scoped=true&"
import script from "./Currencies.vue?vue&type=script&lang=js&"
export * from "./Currencies.vue?vue&type=script&lang=js&"
import style0 from "./Currencies.vue?vue&type=style&index=0&id=1bc3cf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3cf0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc3cf0a')) {
      api.createRecord('1bc3cf0a', component.options)
    } else {
      api.reload('1bc3cf0a', component.options)
    }
    module.hot.accept("./Currencies.vue?vue&type=template&id=1bc3cf0a&scoped=true&", function () {
      api.rerender('1bc3cf0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/Currencies.vue"
export default component.exports